'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pacomoDecorator = exports.pacomoTransformer = undefined;

var _reactPacomo = require('@gadventures/react-pacomo');

var _withPackageName = (0, _reactPacomo.withPackageName)('grex'),
    pacomoDecorator = _withPackageName.decorator,
    pacomoTransformer = _withPackageName.transformer;

exports.pacomoTransformer = pacomoTransformer;
exports.pacomoDecorator = pacomoDecorator;


//////////////////
// WEBPACK FOOTER
// ./app/utils/pacomo.js
// module id = 6
// module chunks = 0